import React, { useEffect, useState } from 'react';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { FacturasAdapter } from '../../../../../infraestructure/persistence/rest/FacturasAdapter';
import { ComboEjerciciosFacturacionExpatriados } from './combo';

export const SelectorEjerciciosFacturacionExpatriados = (props: any) => {
	
	const api = new FacturasAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [ejercicios, setEjercicios] = useState<any>([])
	let result: any;
  
    useEffect(()=>{getEjercicios();},[])

	const getEjercicios = async () => {
		try {
			result = await api.ListarEjerciciosFacturacionExpatriados();
			if(result.data && result.data!=="")
			{
				setEjercicios([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

  return <ComboEjerciciosFacturacionExpatriados {...props} data={ejercicios}/>
};